import EventBus from '../events'
import Vue from 'vue'
import {api} from 'macarons'
import cgApi from '../api'

let defaultId = 0

export default {
  data () {
    return {
      globalFilters: [],
      useGlobalFilters: false,
      filter: []
    }
  },
  created () {
    this.id = --defaultId
    EventBus.$on('filter', this.handleGlobalFilter)
    EventBus.$on('reset', this.handleGlobalReset)
    EventBus.$on('add-filter', this.handleGlobalFilterAdd)
    EventBus.$on('remove-filter', this.handleGlobalFilterRemove)
  },
  mounted () {
    this.$watch('filter', () => {
      this.updateData()
    }, {
      deep: true
    })
  },
  beforeDestroy () {
    EventBus.$off('filter', this.handleGlobalFilter)
    EventBus.$off('reset', this.handleGlobalReset)
    EventBus.$off('add-filter', this.handleGlobalFilterAdd)
    EventBus.$off('remove-filter', this.handleGlobalFilterRemove)
  },
  computed: {
    dimensions () {
      return this.$store.getters['customGraph/dimensions'].map(d => {
        JSON.parse(JSON.stringify(d))
        d.disabled = false
        return d
      })
    }
  },
  methods: {
    setFilterState (filters) {
      this.filter.splice(0, this.filter.length, ...filters.map(f => {
        return {
          filter: this.filter.find(o => cgApi.dimension.uniqueName(o.value) === cgApi.dimension.uniqueName(f.value)),
          state: f
        }
      }).filter(f => f.filter).map(f => {
        return {
          options: f.filter.options,
          value: f.filter.value,
          defaultValues: f.filter.defaultValues || [],
          active: f.filter.disabled ? undefined : f.state.active,
          state: f.filter.state || 'editable'
        }
      }))
      if (this.filter.length) {
        this.setFilters()
      }
    },
    setFilters (useDefault) {
      if (typeof this.$refs.filter === 'undefined') {
        setTimeout(() => this.setFilters(useDefault), 500)
      } else {
        this.$refs.filter.setFilters(useDefault).then(() => {
          this.ready = true
        })
      }
    },
    handleGlobalFilterAdd (filter) {
      if (filter.source !== this.id) {
        if (this.globalFilters.indexOf(filter.filter) === -1) {
          this.globalFilters.push(filter.filter)
        }
        this.useGlobalFilters = true
        this.updateData()
      }
    },
    handleGlobalFilterRemove (filter) {
      if (filter.source !== this.id) {
        const index = this.globalFilters.indexOf(filter.filter)
        if (index > -1) {
          this.globalFilters.splice(index, 1)
        }
        if (!this.globalFilters.length) {
          this.useGlobalFilters = false
        }
        if (this.$refs.graph && typeof this.$refs.graph.deselect !== 'undefined') {
          this.$refs.graph.deselect(filter.data, true)
        }
        this.updateData()
      }
    },
    handleGlobalFilter (filters) {
      this.globalFilters.splice(0, this.globalFilters.length, ...filters.filter(
        f => f.source !== this.id
      ).map(f => f.filter))
      this.useGlobalFilters = this.globalFilters.length ? true : false
      this.updateData()
    },
    handleGlobalReset () {
      this.globalFilters.splice(0)
      this.useGlobalFilters = false
      if (this.$refs.graph && typeof this.$refs.graph.deselectAll !== 'undefined') {
        this.$refs.graph.deselectAll()
      }
      this.updateData()
    },
    loadFilters (filters) {
      return Promise
        .all(filters.map(f => this.$store.dispatch('customGraph/loadValues', f.value)))
        .then(() => {
          this.filter.splice(0, this.filter.length, ...filters.map(f => {
            const dimension = this.$store.getters['customGraph/dimension'](f.value)            
            if (typeof dimension === 'undefined') {
              return null
            }
            return {
              value: dimension,
              options: {
                type: f.type
              },
              defaultValues: f.defaultValues ? f.defaultValues.map(d => dimension.values.find(
                v => cgApi.dimension.uniqueName(v) === d
              )) : [],
              state: f.state || 'editable'
            }
          }).filter(f => f !== null))
        })
    },
    updateFilters (val) {
      const filter = this.filter.find(f => cgApi.dimension.uniqueName(f.value) === val.dimension)
      if (typeof filter === 'undefined') {
        return
      }
      if (typeof filter.active === 'undefined') {
        Vue.set(filter, 'active', [])
      }
      filter.active.splice(0, filter.active.length, ...val.values)
      this.saveState()
      this.updateData()
    },
    serializeFilter () {
      return this.filter.map(f => {
        return {
          value: cgApi.dimension.uniqueName(f.value),
          type: f.options.type,
          defaultValues: f.defaultValues.filter(v => typeof v !== 'undefined').map(v => cgApi.dimension.uniqueName(v)),
          state: f.state || 'editable'
        }
      })
    },
    loadState (id, type) {
      type = typeof type === 'undefined' ? 'custom-graph' : type
      return api.get(`${type}/${id}/state`).then(response => {
        return JSON.parse(response.data.state)
      }).catch(() => {
        return null
      })
    },
    updateData () {
    },
    saveState () {
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/mixins/globalFilterAware.js